/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { setMegaMenuToggle } from "./setMegaMenu";
import { setDrawerButton } from "./setDrawerButton";
import { setAcdnToggle } from "./setAcdnToggle";
import { setRequiredCounter } from "./setRequiredCounter";
import { setAnkerLinkMove } from "./setAnkerLinkMove";

/**
 * Do modules.
 */
function modules() {
  setMegaMenuToggle();
  setDrawerButton();
  setAcdnToggle();
  setRequiredCounter();
  setAnkerLinkMove();
}

export { modules };
